
export default {
  name: 'ControlsLink',
  props: {
    cartItems: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    totalPrice() {
      return (Number(this.cartItems.totalSum)).toFixed(2);
    },
  },
};
